import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Label, Table } from 'react-bootstrap';
import Modal from 'components/Modal';

import IntlDateTime from 'components/layout/IntlDateTime';

import CmsElement from 'components/cms/CmsElement';

class ContentDiff extends React.Component {
  render() {
    const {
      intl: { messages },
      intl,
      appIntl,
      layout,
      show,
      close,
      history,
    } = this.props;

    const countAdded = history ? history.diff.added.length : 0;
    const countRemoved = history ? history.diff.removed.length : 0;
    const countEdited = history ? history.diff.edited.length : 0;
    const countMoved = history ? history.diff.moved.length : 0;

    return (
      <Modal show={show} onHide={close} bsSize="lg" className="full-width">
        <Modal.Header closeButton>
          <Modal.Title>
            <IntlDateTime date={history ? history.cdate : ''} /> {history ? history.public_creator.name : ''}
            <Label bsStyle="success" className={'fs-24 m-l-20 ' + (!countAdded ? 'hint-text ' : '')}>
              <i className="fal fa-plus-square" /> {countAdded}
            </Label>
            <Label bsStyle="danger" className={'fs-24 m-l-10 ' + (!countRemoved ? 'hint-text ' : '')}>
              <i className="fal fa-minus-square" /> {countRemoved}
            </Label>
            <Label bsStyle="primary" className={'fs-24 m-l-10 ' + (!countEdited ? 'hint-text ' : '')}>
              <i className="fal fa-edit" /> {countEdited}
            </Label>
            <Label bsStyle="info" className={'fs-24 m-l-10 ' + (!countMoved ? 'hint-text ' : '')}>
              <i className="fal fa-arrow-square-right" /> {countMoved}
            </Label>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {countAdded > 0 && (
            <div>
              <h3>New elements</h3>

              {history.diff.added.map((element, i) => {
                return (
                  <div key={element.id} className="b-b b-grey p-b-10">
                    <CmsElement index={i.toString()} {...element} intl={intl} appIntl={appIntl} layout={layout} />
                  </div>
                );
              })}
            </div>
          )}

          {countRemoved > 0 && (
            <div>
              <h3>Removed elements</h3>

              {history.diff.removed.map((element, i) => {
                return (
                  <div key={element.id} className="b-b b-grey p-b-10">
                    <CmsElement index={i.toString()} {...element} intl={intl} appIntl={appIntl} layout={layout} />
                  </div>
                );
              })}
            </div>
          )}

          {countEdited > 0 && (
            <div>
              <h3>Edited elements</h3>

              {history.diff.edited.map((element, i) => {
                return (
                  <div key={element.id} className="b-b b-grey p-b-10">
                    <Table responsive hover className="m-b-10">
                      <thead>
                        <tr>
                          <th>Parameter</th>
                          <th>{messages.old_value}</th>
                          <th>{messages.new_value}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {element.diff.map(editedParam => {
                          return (
                            <tr key={editedParam.key}>
                              <td>{editedParam.key}:</td>
                              <td>{editedParam.old}</td>
                              <td>{editedParam.new}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>

                    <CmsElement index={i.toString()} {...element} intl={intl} appIntl={appIntl} layout={layout} />
                  </div>
                );
              })}
            </div>
          )}

          {countMoved > 0 && (
            <div>
              <h3>Moved elements</h3>

              {history.diff.moved.map((element, i) => {
                return (
                  <div key={element.id} className="b-b b-grey p-b-10">
                    <CmsElement index={i.toString()} {...element} intl={intl} appIntl={appIntl} layout={layout} />
                  </div>
                );
              })}
            </div>
          )}
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    layout: state.layout,
  };
};

export default injectIntl(connect(mapStateToProps)(ContentDiff));
